/*
TABLE OF CONTENT

1. Header
   1.1 BuyerInformation
   1.2 SellerInformation
   1.3 BillingInformation
   1.4 ShippingInformation
2. OrderInformation
3. DeliveryConfirmation
4. Positions
5. Attachment
6. Position Dialogs
   6.1 EditDespatchAdviceItem
   6.2 InfoDespatchAdviceItem
   6.3 RejectDespatchAdviceItem
   6.4 AcceptDespatchAdviceItem
7. Attachment Dialogs
   7.1 UploadAttachment
8. Despatch Advice Dialogs
   8.1 RejectDespatchAdvice
   8.2 AcceptDespatchAdvice
*/
import { DespatchAdvice } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createDespatchAdvice = (): DespatchAdvice => {
  return {
    // 1. Header
    header: {
      enabled: true,
      title: getTranslationsForConfig('despatchAdvice.header.title'), // t('despatchAdvice.header.title')
      // 1.1 BuyerInformation
      buyerInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'despatchAdvice.header.buyerInformation.title',
        ), // t('despatchAdvice.header.buyerInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.buyerInformation.labels.externalId',
          ), // t('despatchAdvice.header.buyerInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.buyerInformation.labels.company',
          ), // t('despatchAdvice.header.buyerInformation.labels.company')
        },
        department: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.buyerInformation.labels.department',
          ), // t('despatchAdvice.header.buyerInformation.labels.department')
        },
        name: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.buyerInformation.labels.name',
          ), // t('despatchAdvice.header.buyerInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.buyerInformation.labels.phone',
          ), // t('despatchAdvice.header.buyerInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.buyerInformation.labels.email',
          ), // t('despatchAdvice.header.buyerInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.buyerInformation.labels.address',
          ), // t('despatchAdvice.header.buyerInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.buyerInformation.labels.countryCode',
          ), // t('despatchAdvice.header.buyerInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.sellerInformation.labels.vatNumber',
          ), // t('despatchAdvice.header.sellerInformation.labels.vatNumber')
        },
      },
      // 1.2 SellerInformation
      sellerInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'despatchAdvice.header.sellerInformation.title',
        ), // t('despatchAdvice.header.sellerInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.sellerInformation.labels.externalId',
          ), // t('despatchAdvice.header.sellerInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.sellerInformation.labels.company',
          ), // t('despatchAdvice.header.sellerInformation.labels.company')
        },
        department: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.sellerInformation.labels.department',
          ), // t('despatchAdvice.header.sellerInformation.labels.department')
        },
        name: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.sellerInformation.labels.name',
          ), // t('despatchAdvice.header.sellerInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.sellerInformation.labels.phone',
          ), // t('despatchAdvice.header.sellerInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.sellerInformation.labels.email',
          ), // t('despatchAdvice.header.sellerInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.sellerInformation.labels.address',
          ), // t('despatchAdvice.header.sellerInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.sellerInformation.labels.countryCode',
          ), // t('despatchAdvice.header.sellerInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.sellerInformation.labels.vatNumber',
          ), // t('despatchAdvice.header.sellerInformation.labels.vatNumber')
        },
      },
      // 1.3 BillingInformation
      billingInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'despatchAdvice.header.billingInformation.title',
        ), // t('despatchAdvice.header.billingInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.billingInformation.labels.externalId',
          ), // t('despatchAdvice.header.billingInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.billingInformation.labels.company',
          ), // t('despatchAdvice.header.billingInformation.labels.company')
        },
        department: {
          enabled: false,
          label: getTranslationsForConfig(
            'despatchAdvice.header.billingInformation.labels.department',
          ), // t('despatchAdvice.header.billingInformation.labels.department')
        },
        name: {
          enabled: false,
          label: getTranslationsForConfig(
            'despatchAdvice.header.billingInformation.labels.name',
          ), // t('despatchAdvice.header.billingInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.billingInformation.labels.phone',
          ), // t('despatchAdvice.header.billingInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.billingInformation.labels.email',
          ), // t('despatchAdvice.header.billingInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.billingInformation.labels.address',
          ), // t('despatchAdvice.header.billingInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.billingInformation.labels.countryCode',
          ), // t('despatchAdvice.header.billingInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.billingInformation.labels.vatNumber',
          ), // t('despatchAdvice.header.billingInformation.labels.vatNumber')
        },
      },
      // 1.4 ShippingInformation
      shippingInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'despatchAdvice.header.shippingInformation.title',
        ), // t('despatchAdvice.header.shippingInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.shippingInformation.labels.externalId',
          ), // t('despatchAdvice.header.shippingInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.shippingInformation.labels.company',
          ), // t('despatchAdvice.header.shippingInformation.labels.company')
        },
        department: {
          enabled: false,
          label: getTranslationsForConfig(
            'despatchAdvice.header.shippingInformation.labels.department',
          ), // t('despatchAdvice.header.shippingInformation.labels.department')
        },
        name: {
          enabled: false,
          label: getTranslationsForConfig(
            'despatchAdvice.header.shippingInformation.labels.name',
          ), // t('despatchAdvice.header.shippingInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.shippingInformation.labels.phone',
          ), // t('despatchAdvice.header.shippingInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.shippingInformation.labels.email',
          ), // t('despatchAdvice.header.shippingInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.shippingInformation.labels.address',
          ), // t('despatchAdvice.header.shippingInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'despatchAdvice.header.shippingInformation.labels.countryCode',
          ), // t('despatchAdvice.header.shippingInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: false,
          label: getTranslationsForConfig(
            'despatchAdvice.header.shippingInformation.labels.vatNumber',
          ), // t('despatchAdvice.header.shippingInformation.labels.vatNumber')
        },
      },
    },
    // 2. OrderInformation
    orderInformation: {
      enabled: true,
      title: getTranslationsForConfig('despatchAdvice.orderInformation.title'), // t('despatchAdvice.orderInformation.title')
      orderId: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.orderInformation.form.orderId.label',
        ), // t('despatchAdvice.orderInformation.form.orderId.label')
      },
      orderDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.orderInformation.form.orderDate.label',
        ), // t('despatchAdvice.orderInformation.form.orderDate.label')
      },
      orderDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.orderInformation.form.orderDeliveryDate.label',
        ), // t('despatchAdvice.orderInformation.form.orderDeliveryDate.label')
      },
      termsOfDelivery: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.orderInformation.form.termsOfDelivery.label',
        ), // t('despatchAdvice.orderInformation.form.termsOfDelivery.label')
      },
      orderCurrency: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.orderInformation.form.orderCurrency.label',
        ), // t('despatchAdvice.orderInformation.form.orderCurrency.label')
      },
      confirmationTotalNetItemAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.orderInformation.form.confirmationTotalNetItemAmount.label',
        ), // t('despatchAdvice.orderInformation.form.confirmationTotalNetItemAmount.label')
      },
      orderNotes: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.orderInformation.form.orderNotes.label',
        ), // t('despatchAdvice.orderInformation.form.orderNotes.label')
      },
    },
    // 3. DeliveryConfirmation
    deliveryConfirmation: {
      enabled: true,
      title: getTranslationsForConfig(
        'despatchAdvice.deliveryConfirmation.title',
      ), // t('despatchAdvice.deliveryConfirmation.title')
      // Lieferscheinnummer
      deliveryNoteNumber: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.deliveryNoteNumber.label',
        ), // t('despatchAdvice.deliveryConfirmation.form.deliveryNoteNumber.label')
        placeholder: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.deliveryNoteNumber.placeholder',
        ), // t('despatchAdvice.deliveryConfirmation.form.deliveryNoteNumber.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
          regex: '^.{1,35}$',
          regexErrorMessage: getTranslationsForConfig(
            'despatchAdvice.deliveryConfirmation.form.deliveryNoteNumber.regexErrorMessage',
          ), // t('despatchAdvice.deliveryConfirmation.form.deliveryNoteNumber.regexErrorMessage')
        },
      },
      // Lieferdatum
      deliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.deliveryDate.label',
        ), // t('despatchAdvice.deliveryConfirmation.form.deliveryDate.label')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Lieferart
      deliveryType: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.deliveryType.label',
        ), // t('despatchAdvice.deliveryConfirmation.form.deliveryType.label')
      },
      // Status
      confirmationCode: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.deliveryStatus.label',
        ), // t('despatchAdvice.deliveryConfirmation.form.deliveryStatus.label')
      },
      // Auftragsbestätigungsnummer
      confirmationId: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.confirmationId.label',
        ), // t('despatchAdvice.deliveryConfirmation.form.confirmationId.label')
      },
      // Auftragsbestätigungsdatum
      confirmationDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.confirmationDate.label',
        ), // t('despatchAdvice.deliveryConfirmation.form.confirmationDate.label')
      },
      // GLN (Transportdienstleister)
      gln: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.gln.label',
        ), // t('despatchAdvice.deliveryConfirmation.form.gln.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Firma (Transportdienstsleister)
      company: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.companyTransportServiceProvider.label',
        ), // t('despatchAdvice.deliveryConfirmation.form.companyTransportServiceProvider.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Abteilung
      department: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.department.label',
        ), // t('despatchAdvice.deliveryConfirmation.form.department.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Ansprechpartner
      name: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.name.label',
        ), // t('despatchAdvice.deliveryConfirmation.form.name.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Telefon
      phone: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.phone.label',
        ), // t('despatchAdvice.deliveryConfirmation.form.phone.label')
        readonly: false,
        validation: {
          isRequired: false,
          regex: '^[0-9+() -]*$',
          regexErrorMessage: getTranslationsForConfig(
            'despatchAdvice.deliveryConfirmation.form.phone.regexErrorMessage',
          ), // t('despatchAdvice.deliveryConfirmation.form.phone.regexErrorMessage')
        },
      },
      // E-Mail
      email: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.email.label',
        ), // t('despatchAdvice.deliveryConfirmation.form.email.label')
        readonly: false,
        validation: {
          isRequired: false,
          regex: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$',
          regexErrorMessage: getTranslationsForConfig(
            'despatchAdvice.deliveryConfirmation.form.email.regexErrorMessage',
          ), // t('despatchAdvice.deliveryConfirmation.form.email.regexErrorMessage')
        },
      },
      // Hinweistext Lieferant
      notes: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.deliveryConfirmation.form.notes.label',
        ), // t('despatchAdvice.deliveryConfirmation.form.notes.label')
        readonly: false,
        validation: {
          isRequired: false,
          regex: '^.{1,25}$',
          regexErrorMessage: getTranslationsForConfig(
            'despatchAdvice.deliveryConfirmation.form.notes.regexErrorMessage',
          ), // t('despatchAdvice.deliveryConfirmation.form.notes.regexErrorMessage')
        },
      },
    },
    // 4. Positions
    positions: {
      enabled: true,
      title: getTranslationsForConfig('despatchAdvice.positions.title'), // t('despatchAdvice.positions.title')
      table: {
        enabled: true,
        columns: [
          {
            // Pos-Nr
            dataType: 'string',
            field: 'OrderPosition',
            header: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.orderPosition.header',
            ), // t('despatchAdvice.positions.table.columns.orderPosition.header')
          },
          {
            // Artikel-Nr.
            dataType: 'string',
            field: 'ConfirmationSellerProductId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.confirmationProductId.filterPlaceholder',
            ), // t('despatchAdvice.positions.table.columns.confirmationProductId.filterPlaceholder')
            header: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.confirmationProductId.header',
            ), // t('despatchAdvice.positions.table.columns.confirmationProductId.header')
            sortable: true,
          },
          {
            // Artikelbezeichnung
            dataType: 'string',
            field: 'ConfirmationSellerProductDescription',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.confirmationDescription.filterPlaceholder',
            ), // t('despatchAdvice.positions.table.columns.confirmationDescription.filterPlaceholder')
            header: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.confirmationDescription.header',
            ), // t('despatchAdvice.positions.table.columns.confirmationDescription.header')
            sortable: true,
          },
          {
            // Einheit
            align: 'right',
            dataType: 'string',
            field: 'ConfirmationUnit',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.confirmationUnit.filterPlaceholder',
            ), // t('despatchAdvice.positions.table.columns.confirmationUnit.filterPlaceholder')
            header: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.confirmationUnit.header',
            ), // t('despatchAdvice.positions.table.columns.confirmationUnit.header')
            sortable: true,
          },
          {
            // Bestellmenge
            align: 'right',
            dataType: 'number',
            field: 'Quantity',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.quantity.filterPlaceholder',
            ), // t('despatchAdvice.positions.table.columns.quantity.filterPlaceholder')
            header: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.quantity.header',
            ), // t('despatchAdvice.positions.table.columns.quantity.header')
            sortable: true,
          },
          {
            // Liefermenge
            align: 'right',
            dataType: 'number',
            field: 'ConfirmationQuantity',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.confirmationQuantity.filterPlaceholder',
            ), // t('despatchAdvice.positions.table.columns.confirmationQuantity.filterPlaceholder')
            header: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.confirmationQuantity.header',
            ), // t('despatchAdvice.positions.table.columns.confirmationQuantity.header')
            sortable: true,
          },
          {
            // Lieferstatus
            dataType: 'deliveryStatus',
            field: 'DeliveryStatus',
            filter: true,
            header: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.deliveryStatus.header',
            ), // t('despatchAdvice.positions.table.columns.deliveryStatus.header')
            sortable: true,
          },
          {
            // Tatsächliches Lieferdatum Lieferant
            align: 'right',
            dataType: 'date',
            enabled: false,
            field: 'ConfirmationDeliveryDate',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.confirmationDeliveryDate.filterPlaceholder',
            ), // t('despatchAdvice.positions.table.columns.confirmationDeliveryDate.filterPlaceholder')
            header: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.confirmationDeliveryDate.header',
            ), // t('despatchAdvice.positions.table.columns.confirmationDeliveryDate.header')
            sortable: true,
          },
          {
            // Status
            dataType: 'status',
            field: 'ConfirmationCode',
            filter: true,
            header: getTranslationsForConfig(
              'despatchAdvice.positions.table.columns.confirmationCode.header',
            ), // t('despatchAdvice.positions.table.columns.confirmationCode.header')
            sortable: true,
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'despatchAdvice.positions.table.emptyMessageDetails',
        ), // t('despatchAdvice.positions.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'despatchAdvice.positions.table.emptyMessageTitle',
        ), // t('despatchAdvice.positions.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.OrderDate',
        sortOrder: 1,
      },
    },
    // 5. Attachment
    attachment: {
      enabled: true,
      title: getTranslationsForConfig('despatchAdvice.attachments.title'), // t('despatchAdvice.attachments.title')
      additionalDocuments: {
        enabled: true,
        title: getTranslationsForConfig(
          'despatchAdvice.attachments.table.title',
        ), // t('despatchAdvice.attachments.table.title')
        columns: [
          {
            // Dateiname
            dataType: 'string',
            field: 'Name',
            header: getTranslationsForConfig(
              'despatchAdvice.attachments.table.columns.name.header',
            ), // t('despatchAdvice.attachments.table.columns.name.header')

            width: '400px',
          },
          {
            // Kategorie
            dataType: 'attachmentCategory',
            field: 'Category',
            header: getTranslationsForConfig(
              'despatchAdvice.attachments.table.columns.category.header',
            ), // t('despatchAdvice.attachments.table.columns.category.header')
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'despatchAdvice.attachments.table.emptyMessageDetails',
        ), // t('despatchAdvice.attachments.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'despatchAdvice.attachments.table.emptyMessageTitle',
        ), // t('despatchAdvice.attachments.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.OrderDate',
        sortOrder: 1,
      },
    },
    // 6.1 EditDespatchAdviceItem
    editDespatchAdviceItem: {
      enabled: true,
      // Warencode-Nr.
      itemId: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.itemId.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.itemId.label')
      },
      // Bestätigte Warencode-Nr.
      confirmationItemId: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.confirmationItemId.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationItemId.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Ursprungsland
      countryOfOrigin: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.countryOfOrigin.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.countryOfOrigin.label')
      },
      // Bestätigtes Ursprungsland
      confirmationCountryOfOrigin: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.confirmationCountryOfOrigin.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationCountryOfOrigin.label')
        readonly: false,
        validation: {
          isRequired: false,
          regex: '^[A-Za-z]{1,9}$',
          regexErrorMessage: getTranslationsForConfig(
            'despatchAdvice.positions.table.edit.dialog.form.confirmationCountryOfOrigin.regexErrorMessage',
          ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationCountryOfOrigin.regexErrorMessage')
        },
      },
      gtin: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.gtin.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.gtin.label')
      },
      // Artikel-Nr.
      buyerProductId: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.buyerProductId.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.buyerProductId.label')
      },
      confirmationSellerProductId: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.confirmationSellerProductId.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationSellerProductId.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Beschreibung
      buyerProductDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.buyerProductDescription.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.buyerProductDescription.label')
      },
      confirmationSellerProductDescription: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.confirmationSellerProductDescription.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationSellerProductDescription.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Bestellmenge
      quantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.quantity.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.quantity.label')
      },
      // Offene Menge
      openQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.openQuantity.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.openQuantity.label')
      },
      // Bestätigte Liefermenge
      confirmationQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.confirmationQuantity.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationQuantity.label')
        readonly: false,
        validation: {
          isRequired: true,
          regex: '^(?!-)(\\d+(\\.\\d+)?|\\.\\d+)$',
          regexErrorMessage: getTranslationsForConfig(
            'despatchAdvice.positions.table.edit.dialog.form.confirmationQuantity.regexErrorMessage',
          ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationQuantity.regexErrorMessage')
        },
      },
      // Lieferstatus
      deliveryStatus: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.label')
        options: [
          {
            name: getTranslationsForConfig(
              'despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.options.partly',
            ), // t('despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.options.partly')
            code: 'PARTLY',
          },
          {
            name: getTranslationsForConfig(
              'despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.options.completed',
            ), // t('despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.options.completed')
            code: 'COMPLETE',
          },
        ],
        placeholder: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.placeholder',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.deliveryStatus.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Einheit
      unit: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.orderUnit.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.orderUnit.label')
      },
      // Bestätigte Einheit
      confirmationUnit: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.confirmationUnit.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationUnit.label')
        readonly: true,
        validation: {
          isRequired: false,
        },
      },

      priceBaseQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.orderPriceBaseQuantity.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.orderPriceBaseQuantity.label')
      },
      confirmationPriceBaseQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.confirmationPriceBaseQuantity.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationPriceBaseQuantity.label')
        readonly: true,
        validation: {
          isRequired: false,
        },
      },

      // Preisbezugseinheit (ME)
      priceUnitOfMeasure: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.orderPriceUnitOfMeasure.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.orderPriceUnitOfMeasure.label')
      },
      // Bestätigte Preisbezugseinheit (ME)
      confirmationPriceUnitOfMeasure: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.confirmationPriceUnitOfMeasure.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationPriceUnitOfMeasure.label')
        readonly: true,
        validation: {
          isRequired: false,
          regex: '^.{0,3}$',
          regexErrorMessage: getTranslationsForConfig(
            'despatchAdvice.positions.table.edit.dialog.form.confirmationPriceUnitOfMeasure.regexErrorMessage',
          ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationPriceUnitOfMeasure.regexErrorMessage')
        },
      },

      price: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.orderPrice.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.orderPrice.label')
      },
      confirmationPrice: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.confirmationPrice.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationPrice.label')
        readonly: true,
        validation: {
          isRequired: false,
          regex: '^(?!-)(\\d+(\\.\\d+)?|\\.\\d+)$',
          regexErrorMessage: getTranslationsForConfig(
            'despatchAdvice.positions.table.edit.dialog.form.confirmationPrice.regexErrorMessage',
          ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationPrice.regexErrorMessage')
        },
      },
      priceSum: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.priceSum.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.priceSum.label')
      },
      confirmationPriceSum: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.confirmationPriceSum.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationPriceSum.label')
        readonly: true,
        validation: {
          isRequired: false,
          regex: '^(?!-)(\\d+(\\.\\d+)?|\\.\\d+)$',
          regexErrorMessage: getTranslationsForConfig(
            'despatchAdvice.positions.table.edit.dialog.form.confirmationPriceSum.regexErrorMessage',
          ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationPriceSum.regexErrorMessage')
        },
      },
      allowanceChargeSum: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.allowanceChargeSum.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.allowanceChargeSum.label')
      },
      confirmationAllowanceChargeSum: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.confirmationAllowanceChargeSum.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationAllowanceChargeSum.label')
        readonly: false,
        validation: {
          isRequired: false,
          regex: '^(?!-)(\\d+(\\.\\d+)?|\\.\\d+)$',
          regexErrorMessage: getTranslationsForConfig(
            'despatchAdvice.positions.table.edit.dialog.form.confirmationAllowanceChargeSum.regexErrorMessage',
          ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationAllowanceChargeSum.regexErrorMessage')
        },
      },
      lineItemAmount: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.lineItemAmount.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.lineItemAmount.label')
      },
      confirmationLineItemAmount: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.confirmationLineItemAmount.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationLineItemAmount.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      deliveryDate: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.deliveryDate.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.deliveryDate.label')
      },
      confirmationDeliveryDate: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.edit.dialog.form.confirmationDeliveryDate.label',
        ), // t('despatchAdvice.positions.table.edit.dialog.form.confirmationDeliveryDate.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
    },
    // 6.2 InfoDespatchAdviceItem
    infoDespatchAdviceItem: {
      enabled: true,
      // Warencode-Nr.
      itemId: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.itemId.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.itemId.label')
      },
      // Bestätigte Warencode-Nr.
      confirmationItemId: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationItemId.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationItemId.label')
      },
      // Ursprungsland
      countryOfOrigin: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.countryOfOrigin.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.countryOfOrigin.label')
      },
      // Bestätigtes Ursprungsland
      confirmationCountryOfOrigin: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationCountryOfOrigin.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationCountryOfOrigin.label')
      },
      gtin: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.gtin.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.gtin.label')
      },
      buyerProductId: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.buyerProductId.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.buyerProductId.label')
      },
      confirmationSellerProductId: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationSellerProductId.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationSellerProductId.label')
      },
      buyerProductDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.buyerProductDescription.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.buyerProductDescription.label')
      },
      confirmationSellerProductDescription: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationSellerProductDescription.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationSellerProductDescription.label')
      },
      // Bestellmenge
      quantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.quantity.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.quantity.label')
      },
      // Offene Menge
      openQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.openQuantity.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.openQuantity.label')
      },
      // Bestätigte Liefermenge
      confirmationQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationQuantity.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationQuantity.label')
      },
      // Lieferstatus
      deliveryStatus: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.deliveryStatus.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.deliveryStatus.label')
        options: [
          {
            name: getTranslationsForConfig(
              'despatchAdvice.positions.table.info.dialog.form.deliveryStatus.options.partly',
            ), // t('despatchAdvice.positions.table.info.dialog.form.deliveryStatus.options.partly')
            code: 'PARTLY',
          },
          {
            name: getTranslationsForConfig(
              'despatchAdvice.positions.table.info.dialog.form.deliveryStatus.options.completed',
            ), // t('despatchAdvice.positions.table.info.dialog.form.deliveryStatus.options.completed')
            code: 'COMPLETE',
          },
        ],
      },
      // Einheit
      unit: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.orderUnit.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.orderUnit.label')
      },
      // Bestätigte Einheit
      confirmationUnit: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationUnit.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationUnit.label')
      },

      priceBaseQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.orderPriceBaseQuantity.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.orderPriceBaseQuantity.label')
      },
      confirmationPriceBaseQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationPriceBaseQuantity.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationPriceBaseQuantity.label')
      },

      // Preisbezugseinheit (ME)
      priceUnitOfMeasure: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.orderPriceUnitOfMeasure.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.orderPriceUnitOfMeasure.label')
      },
      // Bestätigte Preisbezugseinheit (ME)
      confirmationPriceUnitOfMeasure: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationPriceUnitOfMeasure.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationPriceUnitOfMeasure.label')
      },

      price: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.orderPrice.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.orderPrice.label')
      },
      confirmationPrice: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationPrice.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationPrice.label')
      },

      priceSum: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.priceSum.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.priceSum.label')
      },
      confirmationPriceSum: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationPriceSum.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationPriceSum.label')
      },

      allowanceChargeSum: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.allowanceChargeSum.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.allowanceChargeSum.label')
      },
      confirmationAllowanceChargeSum: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationAllowanceChargeSum.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationAllowanceChargeSum.label')
      },

      lineItemAmount: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.lineItemAmount.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.lineItemAmount.label')
      },
      confirmationLineItemAmount: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationLineItemAmount.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationLineItemAmount.label')
      },

      deliveryDate: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.deliveryDate.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.deliveryDate.label')
      },
      confirmationDeliveryDate: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationDeliveryDate.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationDeliveryDate.label')
      },

      // Ablehnungsgrund
      confirmationReasonCode: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationReasonCode.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationReasonCode.label')
        options: [
          {
            name: getTranslationsForConfig(
              'despatchAdvice.positions.table.info.dialog.form.confirmationReasonCode.options.code1',
            ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationReasonCode.options.code1')
            code: 'code1',
          },
          {
            name: getTranslationsForConfig(
              'despatchAdvice.positions.table.info.dialog.form.confirmationReasonCode.options.code2',
            ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationReasonCode.options.code2')
            code: 'code2',
          },
        ],
      },
      // Erklärung
      confirmationReasonDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.confirmationReasonDescription.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.confirmationReasonDescription.label')
      },

      notes: {
        enabled: false,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.info.dialog.form.notes.label',
        ), // t('despatchAdvice.positions.table.info.dialog.form.notes.label')
      },
    },
    // 6.3 RejectDespatchAdviceItem
    rejectDespatchAdviceItem: {
      enabled: true,
      // Ablehnungsart
      deliveryStatus: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.rejectItem.dialog.deliveryStatus.label',
        ), // t('despatchAdvice.positions.table.rejectItem.dialog.deliveryStatus.label')
        options: [
          {
            name: getTranslationsForConfig(
              'despatchAdvice.positions.table.rejectItem.dialog.deliveryStatus.options.COMPLETE',
            ), // t('despatchAdvice.positions.table.rejectItem.dialog.deliveryStatus.options.COMPLETE')
            code: 'COMPLETE',
          },
          {
            name: getTranslationsForConfig(
              'despatchAdvice.positions.table.rejectItem.dialog.deliveryStatus.options.PARTLY',
            ), // t('despatchAdvice.positions.table.rejectItem.dialog.deliveryStatus.options.PARTLY')
            code: 'PARTLY',
          },
        ],
        placeholder: getTranslationsForConfig(
          'despatchAdvice.positions.table.rejectItem.dialog.deliveryStatus.placeholder',
        ), // t('despatchAdvice.positions.table.rejectItem.dialog.deliveryStatus.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Ablehnungsgrund
      confirmationReasonCode: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.rejectItem.dialog.confirmationReasonCode.label',
        ), // t('despatchAdvice.positions.table.rejectItem.dialog.confirmationReasonCode.label')
        options: [
          {
            name: getTranslationsForConfig(
              'despatchAdvice.positions.table.rejectItem.dialog.confirmationReasonCode.options.code1',
            ), // t('despatchAdvice.positions.table.rejectItem.dialog.confirmationReasonCode.options.code1')
            code: 'code1',
          },
          {
            name: getTranslationsForConfig(
              'despatchAdvice.positions.table.rejectItem.dialog.confirmationReasonCode.options.code2',
            ), // t('despatchAdvice.positions.table.rejectItem.dialog.confirmationReasonCode.options.code2')
            code: 'code2',
          },
        ],
        placeholder: getTranslationsForConfig(
          'despatchAdvice.positions.table.rejectItem.dialog.confirmationReasonCode.placeholder',
        ), // t('despatchAdvice.positions.table.rejectItem.dialog.confirmationReasonCode.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },

      // Erklärung
      confirmationReasonDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.positions.table.rejectItem.dialog.confirmationReasonDescription.label',
        ), // t('despatchAdvice.positions.table.rejectItem.dialog.confirmationReasonDescription.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
    },
    // 6.4 AcceptDespatchAdviceItem
    acceptDespatchAdviceItem: {
      enabled: true,
    },
    // 7.1 UploadAttachment
    uploadAttachment: {
      enabled: true,
      // Datei
      attachment: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.attachments.table.upload.dialog.form.attachment.label',
        ), // t('despatchAdvice.attachments.table.upload.dialog.form.attachment.label')
        readonly: false,
        validation: {
          isRequired: true,
          maxFileSize: 5000000,
          accept: '.doc, .docx, .pdf, .ppt, .pptx, .xls, .xlsx',
        },
      },
      // Kategorie
      category: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.attachments.table.upload.dialog.form.category.label',
        ), // t('despatchAdvice.attachments.table.upload.dialog.form.category.label')
        options: [
          {
            name: getTranslationsForConfig(
              'despatchAdvice.attachments.table.upload.dialog.form.category.options.transportDocument.name',
            ), // t('despatchAdvice.attachments.table.upload.dialog.form.category.options.transportDocument.name')
            code: 'transportDocument',
          },
          {
            name: getTranslationsForConfig(
              'despatchAdvice.attachments.table.upload.dialog.form.category.options.safetyNotice.name',
            ), // t('despatchAdvice.attachments.table.upload.dialog.form.category.options.safetyNotice.name')
            code: 'safetyNotice',
          },
        ],
        placeholder: getTranslationsForConfig(
          'despatchAdvice.attachments.table.upload.dialog.form.category.placeholder',
        ), // t('despatchAdvice.attachments.table.upload.dialog.form.category.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
    },
    // 8.1 RejectDespatchAdvice
    rejectDespatchAdvice: {
      enabled: true,
      // Ablehnungsgrund
      confirmationReasonCode: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.title.reject.dialog.confirmationReasonCode.label',
        ), // t('despatchAdvice.title.reject.dialog.confirmationReasonCode.label')
        options: [
          {
            name: getTranslationsForConfig(
              'despatchAdvice.title.reject.dialog.confirmationReasonCode.options.notInStock',
            ), // t('despatchAdvice.title.reject.dialog.confirmationReasonCode.options.notInStock')
            code: 'notInStock',
          },
          {
            name: getTranslationsForConfig(
              'despatchAdvice.title.reject.dialog.confirmationReasonCode.options.unknown',
            ), // t('despatchAdvice.title.reject.dialog.confirmationReasonCode.options.unknown')
            code: 'unknown',
          },
          {
            name: getTranslationsForConfig(
              'despatchAdvice.title.reject.dialog.confirmationReasonCode.options.other',
            ), // t('despatchAdvice.title.reject.dialog.confirmationReasonCode.options.other')
            code: 'other',
          },
        ],
        placeholder: getTranslationsForConfig(
          'despatchAdvice.title.reject.dialog.confirmationReasonCode.placeholder',
        ), // t('despatchAdvice.title.reject.dialog.confirmationReasonCode.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Erklärung
      confirmationReasonDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.title.reject.dialog.confirmationReasonDescription.label',
        ), // t('despatchAdvice.title.reject.dialog.confirmationReasonDescription.label')
        readonly: false,
        validation: {
          isRequired: false,
          regex: '^.{0,70}$',
          regexErrorMessage: {
            de: 'Bitte nur 70 Zeichen eingeben.',
            en: 'Please enter a maximum of 70 characters.',
          },
        },
      },
    },
    // 8.2 AcceptDespatchAdvice
    acceptDespatchAdvice: {
      enabled: true,
      // Lieferscheinnummer
      deliveryNoteNumber: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.title.send.dialog.form.deliveryNoteNumber.label',
        ), // t('despatchAdvice.title.send.dialog.form.deliveryNoteNumber.label')
        readonly: true,
        validation: {},
      },
      // Lieferscheindatum
      deliveryNoteDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.title.send.dialog.form.deliveryNoteDate.label',
        ), // t('despatchAdvice.title.send.dialog.form.deliveryNoteDate.label')
        readonly: true,
        validation: {},
      },
      // Lieferdatum
      deliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'despatchAdvice.title.send.dialog.form.deliveryDate.label',
        ), // t('despatchAdvice.title.send.dialog.form.deliveryDate.label')
        readonly: true,
        validation: {},
      },
      table: {
        enabled: true,
        columns: [
          {
            // Pos-Nr
            dataType: 'string',
            field: 'OrderPosition',
            header: getTranslationsForConfig(
              'despatchAdvice.title.send.dialog.table.columns.orderPosition.header',
            ), // t('despatchAdvice.title.send.dialog.table.columns.orderPosition.header')
          },
          {
            // Artikel-Nr.
            dataType: 'string',
            field: 'ConfirmationSellerProductId',
            header: getTranslationsForConfig(
              'despatchAdvice.title.send.dialog.table.columns.confirmationSellerProductId.header',
            ), // t('despatchAdvice.title.send.dialog.table.columns.confirmationSellerProductId.header')
          },
          {
            // Artikelbezeichnung
            dataType: 'string',
            field: 'ConfirmationSellerProductDescription',
            header: getTranslationsForConfig(
              'despatchAdvice.title.send.dialog.table.columns.confirmationSellerProductDescription.header',
            ), // t('despatchAdvice.title.send.dialog.table.columns.confirmationSellerProductDescription.header')
          },
          {
            // Einheit
            align: 'right',
            dataType: 'string',
            field: 'ConfirmationUnit',
            header: getTranslationsForConfig(
              'despatchAdvice.title.send.dialog.table.columns.confirmationUnit.header',
            ), // t('despatchAdvice.title.send.dialog.table.columns.confirmationUnit.header')
          },
          {
            // Bestellmenge
            align: 'right',
            dataType: 'number',
            field: 'Quantity',
            header: getTranslationsForConfig(
              'despatchAdvice.title.send.dialog.table.columns.quantity.header',
            ), // t('despatchAdvice.title.send.dialog.table.columns.quantity.header')
          },
          {
            // Liefermenge
            align: 'right',
            dataType: 'number',
            field: 'ConfirmationQuantity',
            header: getTranslationsForConfig(
              'despatchAdvice.title.send.dialog.table.columns.ConfirmationQuantity.header',
            ), // t('despatchAdvice.title.send.dialog.table.columns.ConfirmationQuantity.header')
          },
          {
            // Lieferstatus
            dataType: 'deliveryStatus',
            field: 'DeliveryStatus',
            header: getTranslationsForConfig(
              'despatchAdvice.title.send.dialog.table.columns.deliveryStatus.header',
            ), // t('despatchAdvice.title.send.dialog.table.columns.deliveryStatus.header')
          },
          {
            // Status
            dataType: 'status',
            field: 'ConfirmationCode',
            header: getTranslationsForConfig(
              'despatchAdvice.title.send.dialog.table.columns.confirmationCode.header',
            ), // t('despatchAdvice.title.send.dialog.table.columns.confirmationCode.header')
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'despatchAdvice.title.send.dialog.table.emptyMessageDetails',
        ), // t('despatchAdvice.title.send.dialog.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'despatchAdvice.title.send.dialog.table.emptyMessageTitle',
        ), // t('despatchAdvice.title.send.dialog.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.OrderDate',
        sortOrder: 1,
      },
    },
  }
}
